import { Tier0, Tier1, Tier2, Tier3 } from '@fanatics/resn-api/instant-rips';

import { WaxChromeColors } from '~/core/wax-chrome-pack-data';

export const themeParams = [
    {
        id: Tier0,
        paletteId: 'default',
        circScale: 1.4,
        circVel: 0.008,
        brightness: 0.34,
        cOffsetVel: 0.006,
        speed: 1,
        mask_radius: 1.5,
    },
    {
        id: Tier1,
        paletteId: 'base',
        circScale: 1.4,
        circVel: 0.01,
        brightness: 0.3,
        cOffsetVel: 0.01,
        speed: 1.3,
        mask_radius: 1.3,
    },
    {
        id: Tier2,
        paletteId: 'chase',
        circScale: 1.3,
        circVel: 0.01,
        brightness: 0.45,
        cOffsetVel: 0.01,
        speed: 1.5,
        mask_radius: 1.4,
    },
    {
        id: Tier3,
        paletteId: 'grail',
        circScale: 1.5,
        brightness: 0.32,
        cOffsetVel: 0.01,
        speed: 1.6,
        mask_radius: 1.34,
    },

    // golden ticket
    {
        id: 'golden-ticket',
        paletteId: 'goldenTicket',
        circScale: 1.4,
        brightness: 0.14,
        mask_radius: 1.2,
    },

    // white-elephant
    {
        id: 'we-default',
        paletteId: 'chase',
        circScale: 1.4,
        brightness: 0.1,
        cOffsetVel: 0.01,
        speed: 1.4,
        mask_radius: 1.2,
    },

    // default
    {
        id: 'default',
        paletteId: 'base',
        circScale: 1.4,
        brightness: 0.1,
        cOffsetVel: 0.01,
        speed: 1.4,
        mask_radius: 1.2,
    },
];

/** Maps `PALETTE_THEME` keys that are not on `themeParams[].paletteId` to a `themeParams[].id` for motion. */
const PALETTE_ID_TO_MOTION_THEME_ID = {
    mega: 'we-default',
    super: 'default',
    infinity: 'default',
};

Object.values(WaxChromeColors).forEach((c) => {
    PALETTE_ID_TO_MOTION_THEME_ID[c.id] = Tier2;
});

/**
 * Resolve Foreground motion row from the active palette id (`ColorPaletteProvider.colorPaletteId`).
 */
export function getThemeParamsForPaletteId(paletteId) {
    const motionId = PALETTE_ID_TO_MOTION_THEME_ID[paletteId];
    if (motionId != null) {
        return (
            themeParams.find((t) => t.id == motionId) ||
            themeParams.find((t) => t.id === 'default')
        );
    }
    return (
        themeParams.find((t) => t.paletteId === paletteId) ||
        themeParams.find((t) => t.id === 'default')
    );
}
